import { apiClient } from '@/shared/api/client'

export async function getDCRs(params = {}) {
  const response = await apiClient.get('/dcr', { params })
  return response.data
}

export async function getDCRById(id) {
  const response = await apiClient.get(`/dcr/${id}`)
  return response.data
}

export async function createDCR(payload) {
  const response = await apiClient.post('/dcr', payload)
  return response.data
}

export async function updateDCR(id, payload) {
  const response = await apiClient.put(`/dcr/${id}`, payload)
  return response.data
}

export async function deleteDCR(id) {
  const response = await apiClient.delete(`/dcr/${id}`)
  return response.data
}
